<template name="tz-form">
	<div :class="`formMain formMain-${align}`">
		<el-form class="form" :model="formObj" :label-position="labelPos">
            <slot name="head"></slot>
			<div v-for="(item,index) in comData" :key="index">
				<el-form-item v-if="item.type" :required="item.required" :label="item.label">

					<el-input :disabled="cantEdit||item.disabled" class="elInput" clearable @input="event_change"
						v-if="item.type=='input'" :type="item.rulesType?item.rulesType:'text'"
						:placeholder="item.placeholder?item.placeholder:`请输入${item.label}`" v-model="item.val">
					</el-input>

					<el-input :disabled="cantEdit||item.disabled" type="textarea" class="elTextArea" clearable
						@input="event_change" v-if="item.type=='textarea'"
						:placeholder="item.placeholder?item.placeholder:`请输入${item.label}`" v-model="item.val">
					</el-input>

					<el-select :filterable="item.filterable" :disabled="cantEdit||item.disabled" clearable @change="event_change"
						v-if="item.type=='select'" :placeholder="item.placeholder?item.placeholder:`请选择${item.label}`"
						v-model="item.val">
						<el-option v-for="item_type in item.typeData" :label="item_type.label"
							:key="item_type.val" :value="item_type.val"></el-option>
					</el-select>

					<div v-if="item.type=='rangeSelect'">
						<el-select :disabled="cantEdit||item.disabled" style="width: 100px;" clearable
							@change="event_change" :placeholder="item.placeholder?item.placeholder:'请选择'"
							v-model="item.val[0]">
							<el-option v-for="(item_type,index_type) in item.typeData[0]" :label="item_type.label"
								:key="index_type" :value="item_type.val"></el-option>
						</el-select>
						<span style="margin: 0px 20px;">-</span>
						<el-select :disabled="cantEdit||item.disabled" style="width: 100px;" clearable
							@change="event_change" :placeholder="item.placeholder?item.placeholder:'请选择'"
							v-model="item.val[1]">
							<el-option v-for="(item_type,index_type) in item.typeData[1]" :label="item_type.label"
								:key="index_type" :value="item_type.val"></el-option>
						</el-select>
					</div>

					<el-radio-group @change="event_change" :disabled="cantEdit||item.disabled" v-model="item.val"
						v-if="item.type=='radioGroup'" class="elRadioGroup">
						<el-radio v-for="(item_type,index_type) in item.typeData" :key="index_type"
							:label="item_type.val">
							{{item_type.label}}
						</el-radio>
					</el-radio-group>

					<el-button v-if="item.type=='button'" type="primary" @click="scButtonClick(item)">{{item.label}}
					</el-button>

					<div v-if="item.type=='img'">
						<el-image v-for="(itemZi,indexZi) in item.typeData" class="form_image" :src="itemZi.val"
							:key="indexZi">
							<template #error>
								<div class="image-slot">
									{{itemZi.placeholder}}
								</div>
							</template>
						</el-image>
					</div>
				</el-form-item>

			</div>

			<slot name="end"></slot>

			<el-form-item>
				<el-button size="medium" v-for="(item,index) in buttonArr" :type="item.type" :key="index"
					@click="buttonTap(item,index)">{{item.label}}</el-button>
			</el-form-item>
		</el-form>

		<slot></slot>
	</div>

</template>

<script>
	export default {
		name: "tz-form",
		props: {
			//是否不可编辑
			cantEdit: {
				type: Boolean,
				default: false
			},
			buttonArr: Array,
			//搜索条件源数据
			comData: Array,
			//对齐模式
			align: {
				type: String,
				default: 'left'
			},
			labelPos: {
				type: String,
				default: 'right'
			}
		},
		components: {},
		data() {
			return {
				formObj: {
					name: ''
				}
			}
		},
		mounted() {},
		methods: {

			// 数据变化
			event_change() {
				let obj = {}
				this.comData.map((item) => {
					if (item.val !== '') {
						obj[item.field] = item.val
						if (item.extraVal) {
							obj[item.field] = item.extraVal
						}
					}
				})
				let res = {}
				res.data = obj
				this.$emit('change', res)
			},

			buttonTap(item, index) {

				this.comData.map(item => {
					if (item.val == undefined) {
						item.val = ''
					}
				})

				let obj = {}

				let isNext = true;
				// map循环中return false无法跳出循环，暂时使用some代替map

				if (item.flag != 'cancel') {
					this.comData.some((item) => {
						if (item.required) {
							let isArr = Array.isArray(item.val)
							if (isArr) {
								// 数组
								let isHasVal = true
								item.val.some(itemVal => {
									if (itemVal === '') {
										isHasVal = false
									}
								})

								if (!isHasVal) {
									isNext = false;
									this.$message({
										type: 'warning',
										message: `请填写必填项${item.label}`,
									})
									return true
								}

							} else {
								// 非数组
								if (item.val === '') {
									isNext = false;
									this.$message({
										type: 'warning',
										message: `请填写必填项${item.label}`,
									})
									return true
								}
							}
						}
						if (item.val !== '') {
							obj[item.field] = item.val
							if (item.extraVal) {
								obj[item.field] = item.extraVal
							}
						}
					})
				}

				if (!isNext) {
					return false
				}

				let res = {}
				res.data = obj
				res.index = index
				res.buttonData = item

				console.log("传值", res)

				this.$emit('buttonTap', res)

			},

		},
		watch: {}
	}
</script>

<style lang="scss" scoped>
	// 对其方式
	@mixin alignStyle($x:center, $y:center, $dir:row) {
		display: flex;
		justify-content: $x;
		align-items: $y;
		flex-direction: $dir;
	}

	.formMain {
		width: 100%;
		@include alignStyle(left);

		&-left {
			@include alignStyle(left);
		}

		&-center {
			@include alignStyle(center);
		}

		&-right {
			@include alignStyle(right);
		}

		&:deep(.is-disabled) {

			.el-input__inner,
			.el-textarea__inner {
				background-color: #fff;
				border-color: #fff;
			}
		}
	}

	.formMain:deep(.el-form-item__content) {
		display: flex;
		justify-content: flex-start;
	}

	.elInput {
		width: 220px;
	}

	.elTextArea {
		width: 320px;
	}

	.elRadioGroup {
		@include alignStyle;
	}

	.form_image {
		width: 120px;
		height: 120px;
		margin-right: 20px;

		&:last-child {
			margin-right: 0px;
		}
	}

	.image-slot {
		width: 118px;
		height: 118px;
		border: 1px solid #e7e7e7;
		@include alignStyle;
		color: #999;
		cursor: pointer;
	}

	.el-input.is-disabled.el-input__inner {
		background-color: #fff;
		border-color: #fff;
	}

	.formMain /deep/ .el-form-item__label {
		width: 260px !important;
	}

	.formMain /deep/ .el-form-item__content {
		margin-left: 260px !important;
		margin-right: 200px !important;
	}
</style>
